import { render } from "./BaseTextArea.vue?vue&type=template&id=f5232c2a"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__